export const ApiEndpoints = {
    GetLists: "/api/list",
    GetPaymentPageURL: (uuid: string) => `/api/proposal/${uuid}/quote/payment`,
    GetProposal: (uuid: string) => `/api/proposal/${uuid}`,
    GetSingleList: (listName: string) => `/api/list/${listName}`,
    SelectQuote: (uuid: string) => `/api/proposal/${uuid}/product`,
    GetTownList: (county: string) => `/api/town/${county}`,
    UpdatePaymentChoice: (uuid: string) => `/api/proposal/${uuid}/payment-option`,
    UpdatePaymentDetails: (uuid: string) => `/api/proposal/${uuid}/pay-monthly`,
    RecallQuote: "/api/proposal/recall",
    CreateProposal: "/api/proposal",
    UpdateProposal: (uuid: string) => `/api/proposal/${uuid}`,
    CreateQuote: (uuid: string) => `/api/proposal/${uuid}/quote`,
    CreateProductQuote: (uuid: string) => `/api/proposal/${uuid}/create-quote-for-product`,
    ResetProposal: (uuid: string) => `/api/proposal/${uuid}/reset`,
    AcceptQuote: (uuid: string) => `/api/proposal/${uuid}/quote/accept`,
    GenerateQuoteDocuments: (uuid: string) => `/api/proposal/${uuid}/generate-quote-documents`,
    SessionRefresh: "/session-refresh",
    SessionEnd: "/session-end",
    RecaptchaVerify: "/api/recaptcha",
    ConfirmRisk: (uuid: string) => `/api/proposal/${uuid}`,
    UpdateMarketingPreferences: (uuid: string) => `/api/proposal/${uuid}/marketing-preferences`
};

export const errorWhitelistedEndpoints = (uuid: string) => [
    "/api/address/",
    ApiEndpoints.UpdatePaymentDetails(uuid),
    ApiEndpoints.RecallQuote,
    `/api/quotes/${uuid}`
];
